import config from '../../../config.json'
import dndItemTypes from '../../../constants/dndItemTypes'
import SaveStateButton from '../../general/SaveStateButton';
import SortableWrapperContainer from '../../../containers/dnd/SortableWrapperContainer';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer';
import Translation from '../../Translation/cont/Translation';
import { generatePath } from 'react-router-dom';
import ListItemMovieContainer from '../../DragAndDropItems/cont/ListItemMovieContainer';
import { MOVIE } from '../../../constants/itemTypes';

const PageSortingMoviesPage= ({programStatus, programError, items, order, goBackPath, params, onReorderProgramItem, onEndReorderProgramItem, onUpdateProgram }) => {
    const closePagePath = 0 === Object.keys(params).length ? goBackPath : generatePath(goBackPath, params)
    const suffixEdit = closePagePath === config.routes.movies.path ? '/edit-item' : ''

    return (
        <WrapperPageSimple
            pageTitleTransId={config.pagesortingmovies.transId}
            closePagePath={closePagePath}
            overlay={
                <RequestOverlayContainer
                    programStatus={programStatus} 
                    programError={programError}
                />
            }
        >
            <div className="program-page program-page-sorting-movies site-content">
                <div className="selections-item single-section">
                    <div className="selections-item-content accordion-item">

                        <p className="selection-drag-hint title-large-light"><Translation id="section_page_drag_movies_to_sort"/></p>

                        <div className="selections-item-selections section-left">
                            <div className="program-list film-content">
                                <ul className="grid-container">
                                    {order.map((itemId, index) =>(
                                        <li key={index} className="item-drag">
                                            <SortableWrapperContainer
                                                index={index} 
                                                moveItem={onReorderProgramItem} 
                                                onEndDrag={onEndReorderProgramItem}
                                                dndType={dndItemTypes.PROGRAM_SORTING}
                                            >
                                                <ListItemMovieContainer
                                                     itemData={items[itemId]}
                                                     pathnameEdit={`${closePagePath}/${MOVIE}/${itemId}${suffixEdit}`}
                                                />
                                            </SortableWrapperContainer>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="save-program-button">
                        <SaveStateButton
                            status={programStatus}
                            transId="publish_program_button"
                            saveState={onUpdateProgram}
                        />
                    </div>
                </div>
            </div>
        </WrapperPageSimple>
    )
}

export default PageSortingMoviesPage